import { Fade, IconButton, Menu, MenuItem } from '@mui/material';
import React, { useCallback } from 'react';
import { Filter } from '@ankr.com/ui';

import { Checkbox } from 'modules/common/components/Checkbox';
import { useIsSMDown } from 'uiKit/Theme/useTheme';
import { useMenu } from 'modules/common/hooks/useMenu';
import { useAuthInstance } from 'modules/auth/hooks/useAuthInstance';

import { usePublicChainsCheckboxStyles } from './usePublicChainsCheckboxStyles';

interface IPublicChainsCheckboxProps {
  isChecked: boolean;
  onClick: (isChecked: boolean) => void;
}

export const PublicChainsCheckbox = ({
  isChecked,
  onClick,
}: IPublicChainsCheckboxProps) => {
  const { isSignedIn } = useAuthInstance();

  const isMobile = useIsSMDown();

  const { anchorEl, handleClose, handleOpen, open } = useMenu();

  const onCloseMenu = useCallback(() => {
    handleClose();
  }, [handleClose]);

  const { classes } = usePublicChainsCheckboxStyles();

  const renderCheckbox = (
    <Checkbox
      isChecked={isChecked}
      onChange={onClick}
      label="Show public chains"
      classNameLabel={classes.publicCheckboxLabel}
    />
  );

  if (isSignedIn) {
    return null;
  }

  if (isMobile) {
    return (
      <>
        <IconButton
          size="small"
          className={classes.mobileMenuButton}
          onClick={handleOpen}
        >
          <Filter className={classes.mobileMenuIcon} />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={onCloseMenu}
          TransitionComponent={Fade}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <MenuItem>{renderCheckbox}</MenuItem>
        </Menu>
      </>
    );
  }

  return renderCheckbox;
};
